import React from "react";
import { useDispatch } from "react-redux";
import {
    FormControlLabel, Checkbox, FormControl, Select, InputLabel, MenuItem, Grid
} from "@material-ui/core";
import T from "i18n-react";
import { mesStyles } from "../../utility/ultrafabStyles";
import { labelArticleOpView, labelWorkcentreOpView, labelMachineOpView } from "../utility";
import DragDrop from "../DragDrop";
import { odpOpViewLabels, odpDetailsOpViewLabels } from "../utility";
import { change } from "../slice";

const Operator = ({ configurationedit, handleChange }) => {
    const myClasses = mesStyles();
    const dispatch = useDispatch()

    const onChange = (data) => {
        dispatch(change(data))
    }

    return (
        <div className={myClasses.dialogForm500}>
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.showUsers} onChange={handleChange} name="showUsers" color="default" />
                }
                label={T.translate("configuration.showUsers")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.showUserEvents} onChange={handleChange} name="showUserEvents" color="default" />
                }
                label={T.translate("configuration.showUserEvents")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.askUserEvent} onChange={handleChange} name="askUserEvent" color="default" />
                }
                label={T.translate("configuration.askUserEvent")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.showCustomerInterface} onChange={handleChange} name="showCustomerInterface" color="default" />
                }
                label={T.translate("configuration.showCustomerInterface")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.showAlerts} onChange={handleChange} name="showAlerts" color="default" />
                }
                label={T.translate("configuration.showAlerts")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.enableInputOperator} onChange={handleChange} name="enableInputOperator" color="default" />
                }
                label={T.translate("configuration.enableInputOperator")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.showExtMachines} onChange={handleChange} name="showExtMachines" color="default" />
                }
                label={T.translate("configuration.showExtMachines")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.enableInsertExtCode} onChange={handleChange} name="enableInsertExtCode" color="default" />
                }
                label={T.translate("configuration.enableInsertExtCode")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.blockingChecks} onChange={handleChange} name="blockingChecks" color="default" />
                }
                label={T.translate("configuration.blockingChecks")}
            />
            <FormControlLabel labelPlacement="end"
                control={
                    <Checkbox checked={configurationedit.showOdpQtyPreview} onChange={handleChange} name="showOdpQtyPreview" color="default" />
                }
                label={T.translate("configuration.showOdpQtyPreview")}
            />
            <br />
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="odpSortOrder">{T.translate("configuration.odpSortOrder")}</InputLabel>
                <Select name="odpSortOrder" value={configurationedit.odpSortOrder} onChange={handleChange}>
                    <MenuItem value="priority">{T.translate("process.priority")}</MenuItem>
                    <MenuItem value="deliveryDate">{T.translate("odp.deliveryDate")}</MenuItem>
                    <MenuItem value="code">{T.translate("odp.code")}</MenuItem>
                </Select>
            </FormControl>
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="labelArticleOpView">{T.translate("configuration.labelArticleOpView.labelArticleOpView")}</InputLabel>
                <Select name="labelArticleOpView" value={configurationedit.labelArticleOpView} onChange={handleChange}>
                    <MenuItem value={labelArticleOpView["code"]}>{T.translate("configuration.labelArticleOpView.code")}</MenuItem>
                    <MenuItem value={labelArticleOpView["codeName"]}>{T.translate("configuration.labelArticleOpView.codeName")}</MenuItem>
                    <MenuItem value={labelArticleOpView["name"]}>{T.translate("configuration.labelArticleOpView.name")}</MenuItem>
                </Select>
            </FormControl>
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="labelWorkcentreOpView">{T.translate("configuration.labelWorkcentreOpView.labelWorkcentreOpView")}</InputLabel>
                <Select name="labelWorkcentreOpView" value={configurationedit.labelWorkcentreOpView} onChange={handleChange}>
                    <MenuItem value={labelWorkcentreOpView["code"]}>{T.translate("configuration.labelWorkcentreOpView.code")}</MenuItem>
                    <MenuItem value={labelWorkcentreOpView["codeName"]}>{T.translate("configuration.labelWorkcentreOpView.codeName")}</MenuItem>
                    <MenuItem value={labelWorkcentreOpView["name"]}>{T.translate("configuration.labelWorkcentreOpView.name")}</MenuItem>
                </Select>
            </FormControl>
            <FormControl margin="normal" fullWidth>
                <InputLabel htmlFor="labelMachineOpView">{T.translate("configuration.labelMachineOpView.labelMachineOpView")}</InputLabel>
                <Select name="labelMachineOpView" value={configurationedit.labelMachineOpView} onChange={handleChange}>
                    <MenuItem value={labelMachineOpView["code"]}>{T.translate("configuration.labelMachineOpView.code")}</MenuItem>
                    <MenuItem value={labelMachineOpView["codeName"]}>{T.translate("configuration.labelMachineOpView.codeName")}</MenuItem>
                    <MenuItem value={labelMachineOpView["name"]}>{T.translate("configuration.labelMachineOpView.name")}</MenuItem>
                </Select>
            </FormControl>
            <Grid container size="small" className={myClasses.confDetailsBox}>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <DragDrop labelsSaved={configurationedit.labelOdpOpView} labelsList={odpOpViewLabels}
                        name="labelOdpOpView" labelType={T.translate("configuration.labelOdpOpView.labelOdpOpView")} change={onChange} />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <DragDrop labelsSaved={configurationedit.labelOdpDetailsOpView} labelsList={odpDetailsOpViewLabels}
                        name="labelOdpDetailsOpView" labelType={T.translate("configuration.labelOdpDetailsOpView.labelOdpDetailsOpView")} change={onChange} />
                </Grid>
            </Grid>
        </div>
    );
};
export default Operator;